import AXIOS from "services/axios";

export const getMmtTagsList = async () => {
  const response = { result: null, err: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/mmt/tags?active=true`
    );
    response.result = data;
  } catch (err) {
    response.err = err.response;
  }
  return response;
};

export const getInactiveMmtTagsList = async () => {
  const response = { result: null, err: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/mmt/tags?active=false`
    );
    response.result = data;
  } catch (err) {
    response.err = err.response;
  }
  return response;
};

export const addTag = async (name) => {
  const response = { result: null, error: null };
  try {
    const { data } = await AXIOS.post(
      `${process.env.REACT_APP_API_PATH}/mmt/tags/`,
      { name }
    );
    response.result = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const editTag = async (obj) => {
  const response = { result: null, error: null };
  try {
    const { data } = await AXIOS.patch(
      `${process.env.REACT_APP_API_PATH}/mmt/tags/${obj.id}/`,
      { ...obj }
    );
    response.result = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const deleteTag = async (id) => {
  const response = { result: null, error: null };
  try {
    const { data } = await AXIOS.delete(
      `${process.env.REACT_APP_API_PATH}/mmt/tags/${id}/`
    );
    response.result = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const activateTag = async (id) => {
  const response = { result: null, error: null };
  try {
    const { data } = await AXIOS.patch(
      `${process.env.REACT_APP_API_PATH}/mmt/tags/${id}/`,
      { is_active: true }
    );
    response.result = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};
